import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styled from "@emotion/styled/macro";
import {
  ErrorModal,
  ReferralForm,
  Snackbar,
} from "@sunrun/experience-ui-components";
import { useReferral } from "providers/Referral";
import { useAppSelector } from "store";

type FormReferralProps = {
  contactId: string | undefined;
};

const FormReferral = ({ contactId }: FormReferralProps) => {
  const authToken = useAppSelector((state) => state.auth.hybridToken);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const {
    isSubmitting,
    error,
    success,
    submitReferral,
    clearError,
    clearSuccess,
  } = useReferral({ contactId, authToken });

  useEffect(() => {
    if (success) {
      setShowSuccessSnackbar(true);
      clearSuccess();
    }
  }, [success, clearSuccess]);

  return (
    <>
      <ReferralForm
        onSave={submitReferral}
        isSubmitDisabled={!contactId || isSubmitting}
      />
      {showSuccessSnackbar &&
        createPortal(
          <ReferralSnackbarHost>
            <Snackbar
              open={showSuccessSnackbar}
              onClose={() => setShowSuccessSnackbar(false)}
              message="Referral submitted successfully!"
              type="success"
              autoHideDuration={5000}
            />
          </ReferralSnackbarHost>,
          document.body
        )}
      {error && (
        <ErrorModal
          testId="referral-error-modal"
          onClose={clearError}
          title="Error"
          error={error}
        />
      )}
    </>
  );
};

const ReferralSnackbarHost = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1100;
  pointer-events: none;

  [data-testid="snackbar-container"] {
    pointer-events: auto;
  }
`;

export { FormReferral };
